/* GFS sitewide AJAX add-to-cart + fly-to-cart (Sitewide cart draft, 2026-10-23).
   Loaded from layout/theme.liquid. Remove the <script> tag there to undo.
   - Ecomus product forms (<wrapp-hdt-pr-frm>: cards, quick view/quick add, product page, sticky ATC):
     the theme still does the add itself (full FormData: variant, qty, selling plan, properties).
     We only force action_added=gfs_fly so the theme neither opens the drawer nor navigates;
     the theme's own cart:change still re-renders the drawer + counts silently.
   - Any other /cart/add form (e.g. homepage gfs cards): we POST its FormData to /cart/add.js ourselves.
   - Buy it now / dynamic checkout buttons are not form submits and are untouched. */
(function(){
  if(window.__gfsAjaxCart)return;window.__gfsAjaxCart=true;
  var ACTION='gfs_fly';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var pending=new WeakMap(); /* form -> {btn, t} */

  function isCartPage(){try{return themeHDN.settings.pageType==='cart'}catch(e){return /\/cart\/?$/.test(location.pathname)}}
  function isAddForm(f){return f&&f.tagName==='FORM'&&/\/cart\/add(\?|$)/.test(f.getAttribute('action')||'')}
  function vis(el){var r=el.getBoundingClientRect();return r.width>8&&r.height>8&&r.bottom>0&&r.right>0&&r.top<innerHeight&&r.left<innerWidth&&getComputedStyle(el).visibility!=='hidden'}
  function area(el){var r=el.getBoundingClientRect();var w=Math.min(r.right,innerWidth)-Math.max(r.left,0),h=Math.min(r.bottom,innerHeight)-Math.max(r.top,0);return w>0&&h>0?w*h:0}
  function findImage(form,btn){
    /* returns {img, from} : the most visible product image near the form; if none is on screen
       (e.g. product page scrolled down to the button), the main image flying from the button */
    var start=form.closest('hdt-card-product,.hdt-card-product,.card,hdt-lazy-modal,hdt-modal,[id*="quick"]')||form;
    var el=start,best=null,any=null;
    for(var depth=0;el&&depth<12;depth++,el=el.parentElement){
      var imgs=el.querySelectorAll('img'),bA=0,bN=0;
      for(var i=0;i<imgs.length;i++){
        var im=imgs[i];if(im.closest('.gfs-fly'))continue;
        var a=vis(im)?area(im):0;if(a>bA){bA=a;best=im}
        var r=im.getBoundingClientRect();var n=r.width*r.height;if(!any&&n>bN&&im.currentSrc){bN=n;any=im}
      }
      if(best)return {img:best};
      if(el.classList&&el.classList.contains('shopify-section'))break;
    }
    if(any&&btn)return {img:any,from:btn.getBoundingClientRect()};
    return any?{img:any}:null;
  }
  function cartIcon(){
    var els=document.querySelectorAll('a[aria-controls="CartDrawer"], a[href$="/cart"]');
    for(var i=0;i<els.length;i++){var r=els[i].getBoundingClientRect();if(r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight)return els[i]}
    return els[0]||null;
  }
  function fly(found){
    var target=cartIcon();
    return new Promise(function(done){
      var img=found&&found.img;
      if(!img||!target||!Element.prototype.animate)return done();
      var a=found.from||img.getBoundingClientRect(),b=target.getBoundingClientRect();
      if(!a.width||!b.width)return done();
      var top=Math.max(a.top,0),bot=Math.min(a.bottom,innerHeight),cx=a.left+a.width/2,cy=(top+bot)/2;
      if(bot<=top){cy=Math.min(Math.max(a.top+a.height/2,40),innerHeight-40)}
      var s=found.from?90:Math.max(56,Math.min(a.width,Math.max(bot-top,0),180));
      var c=document.createElement('img');c.className='gfs-fly';c.src=img.currentSrc||img.src;c.alt='';
      c.style.width=s+'px';c.style.height=s+'px';c.style.left=(cx-s/2)+'px';c.style.top=(cy-s/2)+'px';
      document.body.appendChild(c);
      var dx=b.left+b.width/2-cx,dy=b.top+b.height/2-cy;
      var an=c.animate([
        {transform:'translate(0,0) scale(1)',opacity:1},
        {transform:'translate('+dx*0.45+'px,'+(dy*0.45-60)+'px) scale(.55)',opacity:.95,offset:.5},
        {transform:'translate('+dx+'px,'+dy+'px) scale(.08)',opacity:.35}
      ],{duration:850,easing:'cubic-bezier(.45,.05,.55,.95)',fill:'forwards'});
      var fin=function(){if(c.isConnected)c.remove();done()};
      an.onfinish=fin;setTimeout(fin,1500);
    });
  }
  function bump(n){
    document.querySelectorAll('hdt-cart-count').forEach(function(el){
      if(typeof n==='number')el.innerText=n;
      el.classList.remove('gfs-bump');void el.offsetWidth;el.classList.add('gfs-bump');
    });
    if(typeof n==='number')document.querySelectorAll('hdt-cart-dot').forEach(function(el){el.classList.toggle('is-visible',n>0)});
  }
  function labelEl(btn){return btn.querySelector('.hdt-btn-atc_text')||btn.querySelector('span:not(.sr-only):not(.hdt-loading__spinner)')||btn}
  function flash(btn,text,cls){
    if(!btn)return;
    var l=labelEl(btn);
    if(btn.__gfsOrig==null){btn.__gfsOrig=l.textContent;btn.__gfsL=l}
    btn.classList.remove('gfs-busy','gfs-ok','gfs-err');
    btn.__gfsL.textContent=text;if(cls)btn.classList.add(cls);
    clearTimeout(btn.__gfsT);
    if(cls)btn.__gfsT=setTimeout(function(){reset(btn)},2000);
  }
  function reset(btn){
    clearTimeout(btn.__gfsT);
    if(btn.__gfsL&&btn.__gfsOrig!=null)btn.__gfsL.textContent=btn.__gfsOrig;
    btn.__gfsOrig=null;btn.__gfsL=null;
    btn.classList.remove('gfs-busy','gfs-ok','gfs-err');
  }
  function errMsg(d){
    d=(d&&(d.description||d.message||d))||'';d=String(d);
    if(/sold out/i.test(d))return 'Sold out';
    var m=d.match(/only\s+(\d+)/i);if(m)return 'Only '+m[1]+' left';
    if(/all \d+|can.?t add|cannot add|more|stock|quantity|available/i.test(d))return 'No more stock';
    return 'Couldn\u2019t add';
  }
  function submitterOf(e,form){
    return (e.submitter&&e.submitter.type==='submit'?e.submitter:null)||form.querySelector('button[type="submit"][name="add"],button[type="submit"]')||(form.id&&document.querySelector('button[type="submit"][form="'+form.id+'"]'));
  }
  function success(form,btn,count){
    if(btn)flash(btn,'Added \u2713','gfs-ok');
    return fly(findImage(form,btn)).then(function(){bump(count)});
  }

  /* Theme-handled forms: report success / error */
  document.addEventListener('variant:add',function(e){
    var f=e.target;var p=pending.get(f);if(!p)return;pending.delete(f);clearTimeout(p.t);
    var n=e.detail&&e.detail.cart&&e.detail.cart.item_count;
    success(f,p.btn,typeof n==='number'?n:undefined);
  });
  document.addEventListener('cart:add:error',function(e){
    var f=e.target;var p=pending.get(f);if(!p)return;pending.delete(f);clearTimeout(p.t);
    flash(p.btn,errMsg(e.detail&&e.detail.error),'gfs-err');
  });

  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!isAddForm(form)||isCartPage())return;
    var btn=submitterOf(e,form);
    var themeEl=form.closest('wrapp-hdt-pr-frm,wrapp-hdt-pr-frm-bundle');
    if(themeEl){
      /* let the theme add it, but stop it from opening the drawer / redirecting */
      var inp=form.querySelector('input[name="action_added"]');
      if(!inp){inp=document.createElement('input');inp.type='hidden';inp.name='action_added';form.appendChild(inp)}
      inp.value=ACTION;
      themeEl.hideErrors=false; /* so sold-out errors come back to us */
      if(btn){flash(btn,'Adding\u2026',null);btn.classList.add('gfs-busy')}
      var prev=pending.get(form);if(prev)clearTimeout(prev.t);
      pending.set(form,{btn:btn,t:setTimeout(function(){pending.delete(form);if(btn)reset(btn)},8000)});
      return;
    }
    /* plain forms: do it ourselves */
    e.preventDefault();e.stopImmediatePropagation();
    if(btn&&btn.classList.contains('gfs-busy'))return;
    if(btn){flash(btn,'Adding\u2026',null);btn.classList.add('gfs-busy')}
    var fd=new FormData(form);
    fetch(root+'cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){return r.json().catch(function(){return {}}).then(function(j){return {ok:r.ok,j:j}})})
    .then(function(res){
      if(!res.ok){flash(btn,errMsg(res.j),'gfs-err');return}
      var cartP=fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).catch(function(){return null});
      return Promise.all([success(form,btn),cartP]).then(function(v){
        if(v[1])bump(v[1].item_count);
        /* theme re-renders drawer + counts silently (does NOT open the drawer) */
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      });
    })
    .catch(function(){flash(btn,'Couldn\u2019t add','gfs-err')});
  },true);
})();
